
export const initialState = {
    storeData : [],
    isStorePopUpOpen : "",
    isStoreManagerPopUpOpen : "",
    storeId : "",
    storeFlag : false,
}